module.exports = __webpack_public_path__ + "static/media/Goldeen_gaussian2.053e9cfb.png";